<div class="{{colDef.field}}_td" *ngIf="!AgGridDataTypes.all().includes(colDef?.cellDataType)">
  <app-tos-table-td
    [value]="formatValue(columnDto)"
    [rowData]="record"
    [column]="columnDto"
    (inlineAction)="handleInlineAction($event)"
  />
</div>
<div class="{{colDef.field}}_td" style="height: 100%;align-items: center; display: flex" *ngIf="colDef?.cellDataType === AgGridDataTypes.menuOptions">
  <app-table-menu
    [options]="params?.menuOptions"
    [tableRowData]="record"
    [isOpen]="true"
    (optionSelected)="handleOptionSelected(record, $event)"
  />
</div>

@if (colDef?.cellDataType === AgGridDataTypes.action) {
  <app-tos-table-td
    [value]="CommonUtils.getNestedValue(record,columnDto.fieldName)"
    [rowData]="record"
    [column]="columnDto"
    (inlineAction)="handleInlineAction($event)"
  ></app-tos-table-td>
}

<app-toggle
    *ngIf="colDef?.cellDataType === 'booleanToggle'"
    [ngClass]="'ag-grid-cell'"
    [disable]="!columnDto.editable"
    (toggleChange)="updateBooleanValue($event)"
    [isActive]="CommonUtils.getNestedValue(record,columnDto.fieldName)" />
